import AxiosInstance from 'config/apiServiceApiGateway'

import {
  type VendorDetailsInterface,
  type VendorAccountInterface,
  type VendorCreditLimitSourceApiType,
} from 'features/Enterprise/Vendor/types/VendorManagement'

export interface VendorListInterface {
  category_vendor: string
  company_codes: string[]
  company_name: string
  credit_limit: string
  id: number
  status: boolean
  terms: string
  waiting_time: number
  vendor_account: VendorAccountInterface
  vendor_accounts: VendorAccountInterface[]
  active: boolean
  currency_code: string
  credit_limit_invoice?: number | null
  credit_limit_nominal?: number | null
  credit_limit_source?: VendorCreditLimitSourceApiType | null
}

export interface VendorListPaginatioInterface {
  next_cursor: string
  page_index: number
  prev_cursor: string
  total_elements: number
  page_size: number
}

export interface GetVendorListResponseInterface {
  data: VendorListInterface[]
  pagination: VendorListPaginatioInterface
  error: { code: number; status: boolean; message: string }
}

export type GetVendorQueryType = {
  page_index: number
  company_name: string
  category_vendor: string
}

export interface VendorRequestResponseInterface {
  data: VendorRequestType[]
  pagination: VendorPaginationType
}

export type VendorRequestType = {
  id: number
  vendor_name: string
  company_codes: string[]
  vendor_category: string
  created_at: string
  status: 'DRAFT' | 'PENDING_APPROVAL' | 'REVIEWED' | 'APPROVED' | 'REJECTED' | 'CANCELLED'
  approval_pic: string
  source_type: string
  astro_pic_names: string[]
  changed_sections: string[]
  created_by: string
  platform: string
}

export type VendorPaginationType = {
  sort: string
  direction: string
  page_size: number
  page_index: number
  number_of_elements: number
  total_elements: number
  total_pages: number
}

export type VendorRequestParamsType = {
  order_by?: string
  order_direction?: string
  page_size?: string
  page_index?: number
  vendor_name?: string
  status?: string
  approval_pic?: string
  company_name?: string
  category_vendor?: string
  request_pic?: string
  source_type?: string
  cursor?: string
}

export interface VendorRequestDetailInterface {
  id: number
  status: string
  approval_pic: string
  revision: number
  reason: string
  reject_pic: string
  request_data: VendorDetailsInterface
  existing_data: VendorDetailsInterface
}

export interface SendVendorEmailRequestInterface {
  id: number
  name: string
  email: string
  is_resend_email: boolean
  phone_number: string
  status: string
  vendor_id: number
}

export const getVendors = (params: string) =>
  AxiosInstance.Get<GetVendorListResponseInterface>({
    url: `/commercial/internal/v1/vendors?${params}`,
  })

export const getVendorRequest = (params: VendorRequestParamsType) =>
  AxiosInstance.Get<{ data: VendorRequestResponseInterface }, true>({
    url: '/commercial/internal/:version/vendors/submissions',
    version: 'v1',
    params,
  })

export const postSendVendorEmail = (data: SendVendorEmailRequestInterface) =>
  AxiosInstance.Post({
    url: '/commercial/internal/:version/vendors/accounts/upsert',
    version: 'v1',
    data,
  })

export const putVendorActiveStatus = (id: number, active: boolean) =>
  AxiosInstance.Put({
    url: `/commercial/internal/:version/vendors/${id}/active`,
    version: 'v1',
    data: { active },
  })
